import { Routes, Route } from "react-router-dom";
import Login from "./components/Auth/Login";
import SignUp from "./components/Auth/SignUp";
import Logout from "./components/Auth/Logout";

import Commission from "./components/Commission";
import Logs from "./components/Logs";
import InternalAdmin from "./components/InternalAdmin";
import ProcessedDocuments from "./components/ProcessedDocuments";
import Integrations from "./components/Integrations";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/logout" element={<Logout />} />

      <Route path="/commissions" element={<Commission />} />
      <Route path="/logs" element={<Logs />} />
      <Route path="/processed-documents" element={<ProcessedDocuments />} />
      <Route path="/integrations" element={<Integrations />} />
      <Route path="/internal-admin" element={<InternalAdmin />} />
    </Routes>
  );
}

export default AppRoutes;
